import React from "react"
import { ButtonGroup, Modal } from "react-bootstrap";
import { Button } from "../../components";

const ModalComp = (props: any) => {
  const { archive, setArchive, message, handleDelete, isDeleting } = props
  return (
    <Modal
      show={archive}
      onHide={() => setArchive(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="regenerate-password"
    >
      <Modal.Header className="border-0 pb-0 pb-2" closeButton>
        <Modal.Title id="contained-modal-title-vcenter fw-semibold">
          Confirmation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Do you want to Archive</p>
        <p className="text-danger">{message}</p>
        <div className="text-end">
          <ButtonGroup>
            <Button
              type="button"
              bname="No"
              name="no"
              id="No"
              onClick={() => setArchive(false)}
              className="btn btn-light rounded-1 mt-1  me-3"
            ></Button>
            <Button
              onClick={handleDelete}
              type="button"
              bname="Yes"
              name="yes"
              id="yes"
              disabled={isDeleting}
              className="btn btn-primary rounded-1 mt-1"
            ></Button>
          </ButtonGroup>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export { ModalComp }
